import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, formatData, enumText, closeCollapsible, downloadFile } from '../../../../utils/util';
import { Input, BackButton, Title, Button, InfiniteScroll, Collapsible } from '../../../../components/UI/ComponentsUI';
import SelectNew from '../../../../components/UI/SelectNew';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import * as actionsStock from '../../../../actions/stockAction';
import StockService from '../../../../services/StockService';
import { ENUMS } from '../../../../utils/constants';

const DiffusionLog = (props) => {
    const [logs, setLogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            initialDate: "",
            finalDate: "",
            chassi: "",
            vin: "",
            partNumber: "",
            status: ""
        });

    const arrStatus = [
        { id: 1, text: translate('stock:diffusion-status-waiting') },
        { id: 2, text: translate('stock:diffusion-status-executed') },
        { id: 3, text: translate('stock:diffusion-status-error') },
    ];

    useEffect(() => {
        if (props.logs?.items?.length > 0) {
            if (logs.length > 0 && currentPage === 0) {
                setLogs([...props.logs.items]);
            } else {
                setLogs((prevState) => ([...prevState, ...props.logs.items]));
            }
        } else {
            setLogs([]);
        }
        // eslint-disable-next-line
    }, [props?.logs?.items]);

    const getLogFilter = (click) => {
        const currentPageList = click ? 0 : currentPage;
        if (click) {
            setCurrentPage(0);
        }
        props.getLogs(Object.assign(filter, {
            PageSize: 25,
            PageIndex: currentPageList
        }), () => {
            closeCollapsible("filterLogs");
        });
    }

    const getLogReport = () => {
        props.getReport(filter, (response) => {
            downloadFile(response, `${translate('logDiffusion', 'stock')}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", true);
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    useEffect(() => {
        if (currentPage > 0) {
            getLogFilter(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectChange = (item) => {
        props.selectLog(item);
        props.history.push({
            pathname: `./log/details`
        });
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('logDiffusion', 'stock')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterLogs"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <form id="getLogs" className="col s12">
                                <div className="row" style={{ padding: '10px' }}>
                                    <div className="input-field col s5 no-padding m5">
                                        <Input
                                            defaultValue={filter.initialDate}
                                            type="date"
                                            label={translate('date-start', 'stock')}
                                            id="initialDate"
                                            name="initialDate"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field col s5 no-padding m5">
                                        <Input
                                            defaultValue={filter.finalDate}
                                            type="date"
                                            label={translate('date-end', 'stock')}
                                            id="finalDate"
                                            name="finalDate"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field col s5 no-padding" >
                                        <Input
                                            label={translate('stock:partnumber')}
                                            id="partNumber"
                                            name="partNumber"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={filter?.partNumber}
                                            numericonly="true"
                                            leadingzeros={11}
                                        />
                                    </div>
                                    <div className="input-field col s5 no-padding" >
                                        <Input
                                            label="Chassi"
                                            id="chassi"
                                            name="chassi"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={filter?.chassi}
                                        />
                                    </div>
                                    <div className="input-field col s5 no-padding" >
                                        <Input
                                            label="VIN"
                                            id="vin"
                                            name="vin"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={filter?.vin}
                                        />
                                    </div>
                                    <div className="no-padding col s5">
                                        <SelectNew
                                            required
                                            id="status"
                                            name="status"
                                            display="name"
                                            placeHolder={translate('choose-one-option', 'general')}
                                            data={arrStatus}
                                            value={filter.status}
                                            change={(e) => {
                                                onChange(e);
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>
                        }
                    />
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text={translate('stock:search')} onClick={() => getLogFilter(true)} />
                    </div>
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text={translate('general:download')} onClick={getLogReport} />
                    </div>
                </div>
                <div id="loglist">
                    <InfiniteScroll
                        page={props.logs?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        hasMore={currentPage < props.logs?.totalPages}
                        data={logs.map((item) => (
                            <div
                                className="row"
                                style={{ display: 'block', marginBottom: '0px', marginLeft: '0px', cursor: 'pointer' }}
                                onClick={() => {
                                    onSelectChange(item);
                                }}
                                key={`log_${item.id}`}
                                role="none"
                            >
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {item.partNumber}
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {translate('stock:diffusion-log-qtd')}: {item.quantity}
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    Chassi: {item.chassi}
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    VIN: {item.vin}
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    CIS: {item.cis}
                                </span>
                                <div className="col s12 second-text-color">
                                    {translate('stock:diffusion-log-status')}: {translate(enumText(ENUMS.eDiffusionLogStatus, item.status || ''))} - {formatData(item?.createdOn || '')}
                                </div>
                            </div>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        logs: state.stockReducer.diffusions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLogs: (filter, callback) => {
            dispatch(StockService.searchDiffusion(filter, callback));
        },
        getReport: (filter, callback) => {
            dispatch(StockService.searchDiffusionReport(filter, callback));
        },
        selectLog: (item) => {
            dispatch(actionsStock.selectDiffusionLog(item));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DiffusionLog)));
